import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { checkModifica, authLink } from 'app/utils/boolean-input';

@Component({
  selector: 'demo-logo-comune',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './logo-comune.component.html',
})
export class DemoLogoComuneComponent {

    ckeckModifica(){
        return checkModifica()
    }


    authLink(url: string){
        return authLink(url)
    }

}
